import { QueryClient, QueryCache, MutationCache } from '@tanstack/react-query';
import { handleFailedRequest } from 'utils/failedRequestHandler';

export const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            retry: 2,
            refetchOnWindowFocus: true
        },
        mutations: {
            retry: false
        }
    },
    queryCache: new QueryCache({
        onError: (error) => handleFailedRequest(error)
    }),
    mutationCache: new MutationCache({
        onError: (error) => handleFailedRequest(error)
    })
});
